import { Service } from '@common/types';
import { Box } from '@wix/design-system';
import _ from 'lodash';
import { FC } from 'react';
import { useServiceFormatter } from '../hooks/useServiceFormatter';
import ServiceCard from './ServiceCard';
import s from '../StartingRates.module.scss';

type ServicesListProps = {
  services: Service[];
  showPadding?: boolean;
};

const ServicesList: FC<ServicesListProps> = ({ services }) => {
  const { startingPriceFormatter, isLastService, isFirstService } =
    useServiceFormatter();

  return (
    <Box
      dataHook="services-list"
      direction="vertical"
      width="100%"
      overflowX="scroll"
      backgroundColor="#f4edff"
      borderRadius="8px"
      height="fit-content"
      flex="63"
    >
      {_.map(services, (service, index) => {
        const isLast = isLastService(index, services);
        const isFirst = isFirstService(index);

        return (
          <ServiceCard
            key={service.id}
            service={service}
            isLast={isLast}
            isFirst={isFirst}
            startingPriceFormatter={startingPriceFormatter}
          />
        );
      })}
    </Box>
  );
};

export default ServicesList;
